import { Component, HostListener, OnInit, Inject, DOCUMENT } from '@angular/core';
import { AuthService } from '_services/auth.service';
import { UnivPrefsService } from '_services/univ-prefs.service';
import { Router } from '@angular/router';


import { environment } from 'environments/environment';
import { NgStyle, AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { DraftModeComponent } from '../../_dashboard/draft-mode/draft-mode.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [NgStyle, MatButton, AsyncPipe, DraftModeComponent, NgTemplateOutlet]
})
export class HeaderComponent implements OnInit {
  private static readonly FULL_HEIGHT = 100;
  private static readonly SMALL_HEIGHT = 50;
  private static readonly SCROLL_BUFFER = 10;

  public headerHeight = HeaderComponent.FULL_HEIGHT;
  public devServer = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public authService: AuthService,
    public router: Router,
    public ups: UnivPrefsService) { }

  ngOnInit() {
    this.setHeaderHeight(HeaderComponent.FULL_HEIGHT);
    this.devServer = environment.database === 'dev';
  }

  logout() {
    this.ups.unload();
    this.authService.logout();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const { FULL_HEIGHT, SMALL_HEIGHT, SCROLL_BUFFER } = HeaderComponent;
    const scrollY = window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;

    if (scrollY >= SCROLL_BUFFER && scrollY <= SMALL_HEIGHT + SCROLL_BUFFER) {
      this.setHeaderHeight(FULL_HEIGHT + SCROLL_BUFFER - scrollY);
    } else if (scrollY > SMALL_HEIGHT + SCROLL_BUFFER) {
      this.setHeaderHeight(SMALL_HEIGHT);
    } else {
      this.setHeaderHeight(FULL_HEIGHT);
    }
  }

  private setHeaderHeight(height: number) {
    this.headerHeight = height;
    this.document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

}
